import React, {useEffect, useState} from 'react';
import {isMobile} from 'react-device-detect';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import MainTitleComponent from './Headline/MainTitleComponent';
import { stepEnum } from './ChangePricePlanConsts';
import {gAChangePPWarningPage, gAChangePPWarningPageContinueClick, gAChangePPWarningPageCancelClick} from './reports/gaReports';
import {dwhWarningPagePageDisplay} from './reports/dwhReports';

const WarningComponent = ({props, startOver}) => {
  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }

    if (props.data.selectedAccountExtendedData.banlvl_pp_unlimited == 'Y') {
      gAChangePPWarningPage();
      //DWH
      const currentOfferId = props.data.selectedAccount?.pricePlan;
      const pageURL = window.location.href;
      const customerName = `${props.userData.loginData?.userDetails?.firstName} ${props.userData.loginData?.userDetails?.lastName}`;
      const id = props.userData.loginData?.userDetails?.IDNumber;
      const subscriber = props.userData.loginData?.userDetails?.contactNumber;
      const phoneNumber = props.data.selectedAccount?.subscriberNo;
      dwhWarningPagePageDisplay({currentOfferId, subscriber, pageURL, customerName, id, phoneNumber});
    }
  }, []);

  const warningMessageClickButton = async (ifContinue) => {
    if (ifContinue) {
      gAChangePPWarningPageContinueClick();
      await props.setWarningConfirmation(true);
      if (props.data.allCellularPackagesForAccountData?.length > 1) {
        props.saveToHistory('warning');
      } else {
        props.saveToHistory();
      }
      props.handleCurrentStep({step: stepEnum.PACKAGE_SELECT, error: false});
    } else {
      gAChangePPWarningPageCancelClick();
      startOver();
    }
  };

  return (
    <div className={`warning-buttons-area m-auto`}>
      <MainTitleComponent title={'שינוי חבילת סלולר'} />
      <div className='warning-failure-container'>
        <div className='justify-content-center max-width-440 mr-auto ml-auto bold main-text d-block'>
          <p>רק שניה, זה חשוב</p>
        </div>
        <div className='description-section description-section max-width-440 mr-auto ml-auto'>
          <div className='justify-content-center description text-center'>
            <p>מנוי {props.data.selectedAccount.subscriberNo} משויך לחבילה שבה המחיר תלוי בכמות המנויים.</p>
          </div>
          <div className='justify-content-center'>
            <div className='description text-center'>
              <p>שינוי חבילה למנוי זה, עלול להשפיע על המחיר של המנויים הנוספים.</p>
            </div>
          </div>
        </div>

        <div className={`justify-content-center mr-auto ml-auto ${isMobile ? '' : 'd-flex'}`}>
          <div className={`d-flex btn-wrapper cancel-process m-auto ${isMobile ? '' : 'btn-290'}`}>
            <BtnSubmit onclick={() => warningMessageClickButton(false)} text='תנו לי לחשוב על זה'></BtnSubmit>
          </div>

          <div className={`d-flex btn-wrapper m-auto ${isMobile ? '' : 'btn-290'}`}>
            <BtnSubmit onclick={() => warningMessageClickButton(true)} text='הבנתי, בואו נמשיך'></BtnSubmit>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WarningComponent;
